module.exports = __webpack_public_path__ + "img/logo-shape.37686956.svg";